/** @format */

import React, { useEffect } from 'react';
import useCollapse from 'react-collapsed';
import { useTranslation } from 'react-i18next/hooks';
import ReactResizeDetector from 'react-resize-detector';
import { useStoreState, useStoreActions } from 'easy-peasy';

import Background from '../Background';
import Booking from '../Booking/Booking';

function TopSection() {
    const [t] = useTranslation('translation');

    const cart = useStoreState((state) => state.cart);
    const data = useStoreState((state) => state.topSection);
    const service = useStoreActions((actions) => actions.topSection);
    const travelsSelect = useStoreState((state) => state.travelsSelect);

    const collapseStyles = {
        transitionDuration: '500ms',
        transitionTimingFunction: 'cubic-bezier(0.68, -0.55, 0.49, 0.99)',
    };

    const { getCollapseProps, getToggleProps, isOpen } = useCollapse({
        defaultOpen: true,
        collapseStyles,
    });

    const handleResize = (width, height) => {
        service.setSpacerHeight(height);
    };

    useEffect(() => {
        const height = document.getElementById(
            'topSectionCollapsable',
        ).clientHeight;
        service.setSpacerHeight(height);
    }, [cart, service, travelsSelect]);

    return (
        <div>
            <ReactResizeDetector
                handleWidth
                handlHeight
                querySelector='.collapsable'
                onResize={handleResize}
            >
                {({ height }) => (
                    <div className='collapsable-container'>
                        <Background />
                        <div
                            className='collapsable shadow topSection'
                            id='topSectionCollapsable'
                        >
                            <div
                                className='collapsable-content'
                                {...getCollapseProps()}
                            >
                                <h1>{t('yourJourney')}</h1>
                                <div className='verticalSpace12' />
                                <Booking booking={cart} />
                            </div>
                            <div className='buttons'>
                                <button
                                    className={isOpen ? 'collapse' : 'expand'}
                                    {...getToggleProps()}
                                ></button>
                            </div>
                        </div>
                        <div
                            className='spacer'
                            style={{
                                height: isOpen ? data.spacerHeight : '5rem',
                            }}
                        ></div>
                    </div>
                )}
            </ReactResizeDetector>
        </div>
    );
}

export default TopSection;
